export default {
  // 页面标题
  pageTitle: '预警中心',

  // 模板业务类型
  messageType: {
    registerVerificationCode: '注册验证码',
    loginVerificationCode: '用户登录验证码',
    passwordResetVerificationCode: '重置密码验证码',
    changeEmailMobileCode: '身份验证码',
    passwordResetNotice: '重置密码通知',
    createUserNotice: '创建用户通知',
    demoReservationNotice: '留资信息通知',
    aiCustomerLetter: 'AI获客开发信',
    aiCustomerFreight: 'AI获客运价推广',
    testEmailConfig: '测试邮箱配置'
  },

  // Tab标签
  tabs: {
    notificationSubscription: '通知订阅设置',
    templateSettings: '通知模板设置',
    emailConfig: '邮箱配置',
    wechatConfig: '企微API配置',
    wechatWorkRpa: '企微RPA配置',
    sentEmails: '已发邮件'
  },

  // 通用文案
  common: {
    selectAll: '全选',
    invertSelect: '反选',
    email: '邮件',
    wechat: '企微',
    yes: '是',
    no: '否',
    search: '搜索',
    reset: '重置',
    create: '新建',
    edit: '编辑',
    delete: '删除',
    view: '查看',
    confirm: '确定',
    cancel: '取消',
    copy: '复制',
    paste: '粘贴',
    status: {
      enabled: '启用',
      disabled: '停用',
      inactive: '禁用'
    }
  },

  // 邮箱配置
  emailConfig: {
    // 搜索表单
    search: {
      name: '配置名称',
      namePlaceholder: '请输入配置名称',
      purpose: '邮件配置用途',
      purposePlaceholder: '请选择用途',
      category: '配置分类',
      categoryPlaceholder: '请选择分类',
      all: '全部',
      senderName: '发件人名称',
      senderNamePlaceholder: '请输入发件人名称',
      senderEmail: '发件人邮箱',
      senderEmailPlaceholder: '请输入发件人邮箱',
      smtpServer: 'SMTP服务器',
      smtpServerPlaceholder: '请输入SMTP服务器',
      searchButton: '搜索',
      resetButton: '重置',
      createButton: '新建配置'
    },

    // 表格列
    table: {
      name: '配置名称',
      purpose: '邮件配置用途',
      category: '配置分类',
      senderName: '发件人名称',
      senderEmail: '发件人邮箱',
      smtpServer: 'SMTP服务器',
      encryption: '加密方式',
      testStatus: '测试状态',
      ifDefault: '默认配置',
      actions: '操作',
      view: '查看',
      edit: '编辑',
      delete: '删除',
      setDefault: '设为默认',
      testEmail: '测试邮箱',
      testConfig: '测试配置',
      yes: '是',
      no: '否',
      encryptionNone: '无',
      encryptionSSL: 'SSL',
      encryptionTLS: 'TLS',
      testStatusUntested: '未测试',
      testStatusPassed: '测试通过',
      testStatusFailed: '测试失败'
    },

    // 表单
    form: {
      title: {
        create: '新建邮箱配置',
        edit: '编辑邮箱配置',
        view: '查看邮箱配置'
      },
      name: '配置名称',
      namePlaceholder: '请输入配置名称',
      nameRequired: '请输入配置名称',
      nameMax: '配置名称长度不能超过100',
      purpose: '邮件配置用途',
      purposePlaceholder: '请选择邮件配置用途',
      purposeRequired: '请选择邮件配置用途',
      category: '配置分类',
      categoryPlaceholder: '请选择配置分类',
      categoryRequired: '请选择配置分类',
      senderName: '发件人名称',
      senderNamePlaceholder: '请输入发件人名称',
      senderNameRequired: '请输入发件人名称',
      senderEmail: '发件人邮箱',
      senderEmailPlaceholder: '请输入发件人邮箱',
      senderEmailRequired: '请输入发件人邮箱',
      senderEmailInvalid: '请输入有效的邮箱地址',
      smtpServer: 'SMTP服务器',
      smtpServerPlaceholder: '请输入SMTP服务器地址',
      smtpServerRequired: '请输入SMTP服务器地址',
      smtpPort: 'SMTP端口',
      smtpPortPlaceholder: '请输入SMTP端口',
      smtpPortRequired: '请输入SMTP端口',
      encryption: '加密方式',
      encryptionPlaceholder: '请选择加密方式',
      smtpAccount: 'SMTP账号',
      smtpAccountPlaceholder: '请输入SMTP账号',
      smtpAccountRequired: '请输入SMTP账号',
      smtpPassword: '授权码/SMTP密码',
      smtpPasswordPlaceholder: '请输入授权码/SMTP密码',
      smtpPasswordRequired: '请输入授权码/SMTP密码',
      replyEmail: '回复邮箱',
      replyEmailPlaceholder: '请输入回复邮箱',
      replyEmailInvalid: '请输入有效的邮箱地址',
      enableSignature: '启用签名',
      signature: '邮件签名',
      signaturePlaceholder: '请输入邮件签名',
      sendLimit: '单次发送数量限制',
      sendLimitPlaceholder: '请输入单次发送数量限制',
      sendLimitRequired: '请输入单次发送数量限制',
      sendLimitTooltip: '避免一次性发送过多邮件导致邮箱被封，建议根据邮箱服务商限制合理设置',
      ifDefault: '设为默认配置',
      cancelButton: '取消',
      confirmButton: '确定',
      testButton: '测试配置'
    },

    // 测试配置
    test: {
      resultTitle: '测试结果',
      successMessage: '测试成功',
      failureMessage: '测试失败',
      closeButton: '关闭'
    },

    // 删除确认
    delete: {
      title: '删除确认',
      message: '确定要删除邮箱配置"{name}"吗？',
      cancelButton: '取消',
      confirmButton: '确定'
    },

    // 消息提示
    messages: {
      createSuccess: '邮箱配置创建成功',
      createFailed: '邮箱配置创建失败',
      updateSuccess: '邮箱配置更新成功',
      updateFailed: '邮箱配置更新失败',
      deleteSuccess: '邮箱配置删除成功',
      deleteFailed: '邮箱配置删除失败',
      setDefaultSuccess: '已设为默认配置',
      setDefaultFailed: '设置默认配置失败'
    },

    purposeTypes: {
      ALERT: '发送预警',
      AI_MARKETING: '发送AI营销',
      RECEIVE_BOOKING: '接收托书',
      RECEIVE_SO: '接收SO'
    },
    categoryTypes: {
      '1': '预警中心',
      '2': '业务模块'
    },
    /** 下拉/校验用元数据（与 purposeTypes、categoryTypes 保持一致） */
    meta: {
      purposeKeys: ['ALERT', 'AI_MARKETING', 'RECEIVE_BOOKING', 'RECEIVE_SO'],
      categoryValues: [1, 2]
    }
  },

  // 已发邮箱
  sentEmails: {
    // 搜索表单
    search: {
      subject: '邮件主题',
      subjectPlaceholder: '请输入邮件主题',
      recipients: '收件人',
      recipientsPlaceholder: '请输入收件人邮箱',
      operator: '操作人',
      operatorPlaceholder: '请选择操作人',
      status: '发送状态',
      statusPlaceholder: '请选择发送状态',
      emailType: '邮件类型',
      emailTypePlaceholder: '请选择邮件类型',
      sendTimeRange: '发送时间',
      sendTimeRangePlaceholder: ['开始时间', '结束时间'],
      searchButton: '搜索',
      resetButton: '重置'
    },

    // 表格列
    table: {
      subject: '邮件主题',
      recipients: '收件人',
      sendTime: '发送时间',
      emailType: '邮件类型',
      operator: '操作人',
      status: '发送状态',
      recipientCount: '收件人数量',
      actions: '操作',
      view: '查看',
      delete: '删除',
      viewRecipients: '查看收件人'
    },

    // 邮件类型
    emailTypes: {
      ratePromotion: '运价推广',
      developmentLetter: '开发信',
      systemNotification: '系统通知'
    },

    // 发送状态
    status: {
      processing: '处理中',
      completed: '已完成',
      failed: '失败',
      returned: '退回'
    },

    // 查看详情
    detail: {
      title: '邮件详情',
      emailBasicInfo: '邮件基本信息',
      subject: '邮件主题',
      emailType: '邮件类型',
      operator: '操作人',
      sendTime: '发送时间',
      status: '发送状态',
      recipientCount: '收件人数量',
      recipients: '收件人',
      more: '更多',
      viewDetails: '查看详情',
      successCount: '成功数量',
      failedCount: '失败数量',
      emailContent: '邮件内容',
      emailContentPreview: '邮件内容预览',
      closeButton: '关闭'
    },

    // 收件人详情弹窗
    recipientDetails: {
      title: '收件人详情',
      email: '收件人邮箱',
      total: '共{count}个收件人',
      closeButton: '关闭'
    },

    // 收件人详情
    recipients: {
      title: '收件人详情',
      searchPlaceholder: '搜索收件人邮箱',
      email: '收件人邮箱',
      status: '发送状态',
      sendTime: '发送时间',
      errorReason: '失败原因',
      closeButton: '关闭',
      noData: '暂无收件人信息',
      statusSuccess: '成功',
      statusFailed: '失败',
      statusPending: '待发送'
    },

    // 删除确认
    delete: {
      title: '删除确认',
      message: '确定要删除此邮件记录吗？',
      cancelButton: '取消',
      confirmButton: '确定'
    },

    // 消息提示
    messages: {
      deleteSuccess: '邮件记录删除成功',
      deleteFailed: '邮件记录删除失败',
      noPermission: '您没有删除邮件记录的权限'
    }
  },

  // 通知订阅设置
  subscription: {
    actionBar: {
      copyTooltip: '复制当前所有设置',
      copyButton: '复制设置',
      pasteTooltip: '将复制的设置粘贴到选中角色',
      pasteButton: '粘贴设置',
      saveTooltip: '保存当前角色的订阅配置',
      saveButton: '保存',
      notificationConfig: '通知配置管理',
      operationManagement: '操作管理'
    },
    roles: {
      title: '通知角色',
      searchPlaceholder: '搜索角色',
      empty: '请先选择通知角色'
    },
    operations: {
      title: '操作名称',
      searchPlaceholder: '搜索操作',
      columnOperation: '操作',
      columnEmail: '邮件',
      columnWechat: '企微',
      empty: '请先选择通知角色'
    },
    subscribers: {
      title: '订阅角色',
      searchPlaceholder: '搜索角色',
      columnRole: '订阅角色',
      columnEmail: '邮件',
      columnWechat: '企微',
      emptyRole: '请先选择通知角色',
      emptyOperation: '请选择操作名称'
    },
    tooltip: {
      missingTemplate: '该操作无通知模板，可能导致通知失败，请前往【通知模板设置】创建模板'
    },
    messages: {
      selectRoleFirst: '请先选择通知角色',
      selectRoleAndOperation: '请先选择通知角色和操作',
      selectAllOperations: '已全选 {count} 个操作',
      deselectOperations: '已反选 {count} 个操作',
      selectAllSubscribers: '已全选 {count} 个订阅角色',
      deselectSubscribers: '已反选 {count} 个订阅角色',
      copySuccess: '设置已复制',
      pasteSuccess: '设置已粘贴',
      copyFirst: '请先复制设置',
      selectRoleToPaste: '请选择要粘贴的通知角色',
      saveSuccess: '订阅配置已保存'
    }
  },

  // 通知模板设置
  templateSettings: {
    tabs: {
      email: '邮件模板',
      wechat: '企微模板',
      wechatWorkRpa: '企微RPA模板'
    },
    email: {
      filters: {
        templateCodePlaceholder: '模板代码',
        operationPlaceholder: '触发操作',
        descriptionPlaceholder: '模板描述',
        statusPlaceholder: '模板状态',
        creatorPlaceholder: '创建者'
      },
      buttons: {
        search: '搜索',
        reset: '重置',
        create: '新建'
      },
      table: {
        templateCode: '模板代码',
        name: '模板名称',
        operation: '触发操作',
        scenario: '邮箱场景',
        channelConfig: '使用邮箱',
        description: '模板描述',
        status: '模板状态',
        creator: '创建者',
        updatedAt: '最近更新时间',
        actions: '操作'
      },
      actions: {
        enable: '启用',
        disable: '停用',
        edit: '编辑',
        preview: '预览',
        delete: '删除'
      },
      popconfirm: {
        delete: '是否确认删除该邮件模板？'
      },
      messages: {
        loadFailed: '加载邮件模板失败',
        toggle: '模板已{status}',
        toggleFailed: '切换模板状态失败',
        deleteLimited: '不能删除最后一个同操作模板',
        deleteSuccess: '模板删除成功',
        deleteFailed: '删除模板失败'
      }
    },
    wechat: {
      filters: {
        idPlaceholder: '模板ID',
        operationPlaceholder: '触发操作',
        templateTypePlaceholder: '模板类型',
        statusPlaceholder: '模板状态',
        creatorPlaceholder: '创建者'
      },
      buttons: {
        search: '搜索',
        reset: '重置',
        create: '新建'
      },
      table: {
        id: '模板ID',
        name: '模板名称',
        operation: '触发操作',
        templateType: '模板类型',
        description: '模板描述',
        status: '模板状态',
        creator: '创建者',
        updatedAt: '最近更新时间',
        actions: '操作'
      },
      templateTypes: {
        text: '纯文本',
        card: '文本卡片',
        news: '图文消息',
        file: '文件'
      },
      actions: {
        enable: '启用',
        disable: '停用',
        edit: '编辑',
        delete: '删除'
      },
      popconfirm: {
        delete: '是否确认删除该企微模板？'
      },
      messages: {
        loadFailed: '加载企微模板失败',
        toggle: '模板已{status}',
        toggleFailed: '切换模板状态失败',
        deleteLimited: '不能删除最后一个同操作模板',
        deleteSuccess: '模板删除成功',
        deleteFailed: '删除模板失败'
      }
    },
    wechatWorkRpa: {
      filters: {
        idPlaceholder: '模板ID',
        operationPlaceholder: '触发操作',
        templateTypePlaceholder: '模板类型',
        statusPlaceholder: '模板状态',
        creatorPlaceholder: '创建者'
      },
      buttons: {
        search: '搜索',
        reset: '重置',
        create: '新建'
      },
      table: {
        id: '模板ID',
        name: '模板名称',
        operation: '触发操作',
        templateType: '模板类型',
        description: '模板描述',
        status: '模板状态',
        creator: '创建者',
        updatedAt: '最近更新时间',
        actions: '操作'
      },
      templateTypes: {
        text: '纯文本',
        card: '文本卡片',
        news: '图文消息',
        file: '文件'
      },
      actions: {
        enable: '启用',
        disable: '停用',
        edit: '编辑',
        send: '发送',
        preview: '预览',
        delete: '删除'
      },
      popconfirm: {
        delete: '是否确认删除该企微RPA模板？'
      },
      messages: {
        loadFailed: '加载企微RPA模板失败',
        toggle: '模板已{status}',
        toggleFailed: '切换模板状态失败',
        deleteLimited: '不能删除最后一个同操作模板',
        deleteSuccess: '模板删除成功',
        deleteFailed: '删除模板失败'
      }
    }
  },

  // 操作管理弹窗
  operationManagement: {
    title: '操作管理',
    filters: {
      idPlaceholder: '操作ID',
      sourcePlaceholder: '操作来源',
      statusPlaceholder: '操作状态',
      statusAll: '全部',
      creatorPlaceholder: '创建者'
    },
    listHeader: '操作列表',
    buttons: {
      create: '新建操作'
    },
    table: {
      id: '操作ID',
      source: '操作来源',
      status: '状态',
      updater: '更新者',
      updatedAt: '最近更新时间',
      remark: '备注',
      actions: '操作',
      actionName: '操作名称',
      enabledStatus: '启用状态',
      enabledVariables: '关联变量',
      actionDescription: '操作描述',
      variablesCount: '{count} 个变量',
      allVariables: '全部变量'
    },
    actions: {
      edit: '编辑',
      enable: '启用',
      disable: '停用',
      delete: '删除',
      deleteConfirm: '确定要删除该操作吗？'
    },
    messages: {
      toggle: '操作已{status}',
      deleteLast: '无法删除最后一个操作',
      deleteSuccess: '操作删除成功'
    }
  },

  // 操作表单
  operationForm: {
    title: {
      create: '新建操作',
      edit: '编辑操作'
    },
    fields: {
      source: {
        label: '操作来源',
        placeholder: '请选择操作来源',
        required: '请选择操作来源'
      },
      status: {
        label: '操作状态',
        placeholder: '请选择操作状态',
        required: '请选择操作状态'
      },
      variables: {
        label: '关联变量',
        placeholder: '请选择关联变量',
        hint: '请至少选择一个关联变量',
        required: '请至少选择一个关联变量'
      },
      remark: {
        label: '备注',
        placeholder: '请输入备注信息'
      }
    },
    variables: {
      operatorName: '操作人姓名',
      operatorEmail: '操作人邮箱',
      operationTime: '操作时间',
      inquiryNo: '询价单编号',
      inquiryCustomer: '询价客户',
      quotationNo: '报价单编号',
      quotationAmount: '报价金额',
      orderNo: '订单编号',
      orderAmount: '订单金额'
    },
    variableTypes: {
      string: 'string',
      float: 'float',
      datetime: 'datetime'
    },
    messages: {
      createSuccess: '操作创建成功',
      updateSuccess: '操作编辑成功'
    }
  },

  // 邮件模板表单
  emailTemplateForm: {
    title: {
      create: '新建邮件模板',
      edit: '编辑邮件模板'
    },
    fields: {
      templateName: {
        label: '模板名称',
        placeholder: '请输入模板名称',
        required: '请输入模板名称',
        max: '模板名称过长'
      },
      operation: {
        label: '触发操作',
        placeholder: '请选择触发操作',
        required: '请选择触发操作'
      },
      emailScenario: {
        label: '邮箱场景',
        placeholder: '请选择邮箱场景',
        required: '请选择邮箱场景'
      },
      channelConfig: {
        label: '使用邮箱',
        placeholder: '请选择邮箱通道配置',
        required: '请选择使用邮箱'
      },
      description: {
        label: '模板描述',
        placeholder: '请输入模板描述'
      },
      subject: {
        label: '邮件主题',
        placeholder: '请输入邮件主题',
        required: '请输入邮件主题',
        max: '邮件主题过长'
      },
      content: {
        label: '邮件内容',
        placeholder: '请输入邮件内容（支持HTML格式）',
        required: '请输入邮件内容'
      },
      footer: {
        label: '页脚签名',
        placeholder: '请输入页脚签名'
      },
      redirectLink: {
        label: '跳转链接',
        placeholder: '请输入跳转链接',
        invalid: '跳转链接应该为URL格式'
      }
    },
    messages: {
      createSuccess: '邮件模板创建成功',
      updateSuccess: '邮件模板更新成功',
      saveFailed: '保存邮件模板失败'
    },
    scenarios: {
      COMMERCIAL_INVOICE_DRAFT: '商业发票-草稿邮件',
      COMMERCIAL_INVOICE_ORIGINAL: '商业发票-正本邮件',
      COMMERCIAL_INVOICE_ISF: '商业发票-ISF',
      COMMERCIAL_INVOICE_CONTAINER_DETAIL: '商业发票-柜明细发票',
      LOADING_PLAN_DISPATCH: '装柜表-派车',
      SUPPLEMENT_SUPPLIER: '补料-发供应商邮件',
      BIDDING_SE: '招标-海运',
      BIDDING_TC: '招标-拖车',
      WINNING_SE: '中标-海运',
      WINNING_TC: '中标-拖车',
      BOOKING_EMAIL: '邮件订舱',
      TRACKING_EXCEPTION_ALERT: '运踪异常预警',
      OMS_DELIVERY_ORDER_BLOCKED: 'OMS推送阻断',
      SHOKZ_SPACE_INQUIRY_CONFIRM: '询舱确认',
      SHOKZ_CONSIGNMENT_SUPPLIER_CONFIRM: '委托供应商确认'
    },
    /** 邮箱场景枚举键，与 scenarios 键一致 */
    scenarioKeys: [
      'COMMERCIAL_INVOICE_DRAFT',
      'COMMERCIAL_INVOICE_ORIGINAL',
      'COMMERCIAL_INVOICE_ISF',
      'COMMERCIAL_INVOICE_CONTAINER_DETAIL',
      'LOADING_PLAN_DISPATCH',
      'SUPPLEMENT_SUPPLIER',
      'BIDDING_SE',
      'BIDDING_TC',
      'WINNING_SE',
      'WINNING_TC',
      'BOOKING_EMAIL',
      'TRACKING_EXCEPTION_ALERT',
      'OMS_DELIVERY_ORDER_BLOCKED',
      'SHOKZ_SPACE_INQUIRY_CONFIRM',
      'SHOKZ_CONSIGNMENT_SUPPLIER_CONFIRM'
    ],
    /** 附随附件：value 与后端/模板存储一致（中文），label 随语言展示 */
    attachWithEmailOptions: [
      { value: '认证证书', label: '认证证书' },
      { value: '认证报告', label: '认证报告' },
      { value: '运输鉴定报告', label: '运输鉴定报告' },
      { value: '化学环保报告', label: '化学环保报告' },
      { value: '生物致敏报告', label: '生物致敏报告' },
      { value: '电池报告', label: '电池报告' },
      { value: '放行条', label: '放行条' },
      { value: '提单草单', label: '提单草单' },
      { value: '提单正本', label: '提单正本' },
      { value: '电放保函', label: '电放保函' },
      { value: '报关单', label: '报关单' },
      { value: '放行通知书', label: '放行通知书' },
      { value: '报关底单', label: '报关底单' },
      { value: '预税单', label: '预税单' },
      { value: '税金单', label: '税金单' },
      { value: '正式税单', label: '正式税单' },
      { value: '约仓邮件', label: '约仓邮件' },
      { value: 'POD', label: 'POD' }
    ],
    generateAttachmentOptions: [
      { value: '发货通知单', label: '发货通知单' },
      { value: '付款申请单', label: '付款申请单' },
      { value: '商业发票', label: '商业发票' }
    ]
  },

  // 邮件预览
  emailPreview: {
    title: '邮件模板预览',
    viewDetail: '查看详情',
    empty: '暂无邮件内容'
  },

  // 企微RPA预览
  wechatWorkRpaPreview: {
    title: '企微RPA消息预览',
    templateName: '模板名称',
    templateDescription: '模板描述',
    messageContent: '消息内容',
    close: '关闭',
    empty: '暂无消息内容'
  },

  // 通知配置弹窗
  notificationConfigModal: {
    title: '通知配置管理',
    tabs: {
      email: '邮箱',
      wechat: '企微'
    },
    email: {
      configName: '配置名称',
      configNamePlaceholder: '请输入配置名称',
      senderName: '发件人名称',
      senderNamePlaceholder: '请输入发件人名称',
      senderEmail: '发件人邮箱',
      senderEmailPlaceholder: '请输入发件人邮箱',
      replyEmail: '回复邮箱',
      replyEmailPlaceholder: '不可设置回复邮箱',
      smtpServer: 'SMTP服务器地址',
      smtpServerPlaceholder: '请输入SMTP服务器地址',
      port: '端口',
      portPlaceholder: '请输入端口号',
      encryption: '加密方式',
      smtpAccount: 'SMTP账号',
      smtpAccountPlaceholder: '请输入SMTP账号',
      password: '密码',
      passwordPlaceholder: '请输入密码',
      description: '配置描述',
      descriptionPlaceholder: '请输入配置描述',
      isDefault: '是否为默认',
      defaultPlaceholder: '请选择是否默认'
    },
    wechat: {
      configName: '配置名称',
      configNamePlaceholder: '请输入配置名称',
      corpId: '企业ID',
      corpIdPlaceholder: '请输入企业ID',
      agentId: '应用ID',
      agentIdPlaceholder: '请输入应用ID',
      apiSecret: 'API密钥',
      apiSecretPlaceholder: '请输入API密钥',
      status: '状态',
      statusPlaceholder: '请选择状态',
      isDefault: '是否默认',
      remark: '备注',
      remarkPlaceholder: '请输入备注信息'
    },
    messages: {
      saved: '通知配置已保存'
    },
    test: {
      button: '测试连接',
      success: '测试成功',
      failure: '测试失败'
    }
  },

  // 变量选择器
  variableSelector: {
    searchPlaceholder: '搜索变量',
    empty: '未找到匹配的变量',
    button: '插入变量'
  },

  // 企微模板表单
  wechatTemplateForm: {
    title: {
      create: '新建企微模板',
      edit: '编辑企微模板'
    },
    fields: {
      operation: {
        label: '触发操作',
        placeholder: '请选择触发操作',
        required: '触发操作未填写'
      },
      templateType: {
        label: '模板类型',
        placeholder: '请选择模板类型',
        required: '模板类型未填写'
      },
      description: {
        label: '模板描述',
        placeholder: '请输入模板描述'
      },
      textContent: {
        label: '文本内容',
        placeholder: '请输入文本内容',
        required: '文本内容未填写',
        max: '文本内容过长'
      },
      safe: {
        label: '是否是保密消息',
        options: {
          no: '否',
          yes: '是'
        }
      },
      title: {
        label: '标题',
        placeholder: '请输入标题',
        required: '标题未填写',
        max: '标题过长'
      },
      cardDescription: {
        label: '描述',
        placeholder: '请输入描述',
        required: '描述未填写',
        max: '描述过长'
      },
      link: {
        label: '链接',
        placeholder: '请输入链接',
        required: '链接未填写',
        invalid: '链接应该为URL格式'
      },
      buttonText: {
        label: '按钮文字',
        placeholder: '请输入按钮文字'
      },
      newsDescription: {
        label: '描述',
        placeholder: '请输入描述',
        required: '描述未填写',
        max: '描述过长'
      },
      imageUrl: {
        label: '图片链接',
        placeholder: '请输入图片链接'
      },
      file: {
        label: '文件上传',
        button: '上传文件'
      }
    },
    templateTypes: {
      text: '纯文本',
      card: '文本卡片',
      news: '图文消息',
      file: '文件'
    },
    messages: {
      createSuccess: '企微模板创建成功',
      updateSuccess: '企微模板更新成功',
      saveFailed: '保存企微模板失败'
    }
  },

  // 企微RPA模板表单
  wechatWorkRpaTemplateForm: {
    title: {
      create: '新建企微RPA模板',
      edit: '编辑企微RPA模板'
    },
    fields: {
      operation: {
        label: '触发操作',
        placeholder: '请选择触发操作',
        required: '触发操作未填写'
      },
      templateType: {
        label: '模板类型',
        placeholder: '请选择模板类型',
        required: '模板类型未填写'
      },
      description: {
        label: '模板描述',
        placeholder: '请输入模板描述'
      },
      textContent: {
        label: '文本内容',
        placeholder: '请输入文本内容',
        required: '文本内容未填写',
        max: '文本内容过长'
      },
      safe: {
        label: '是否是保密消息',
        options: {
          no: '否',
          yes: '是'
        }
      },
      title: {
        label: '标题',
        placeholder: '请输入标题',
        required: '标题未填写',
        max: '标题过长'
      },
      cardDescription: {
        label: '描述',
        placeholder: '请输入描述',
        required: '描述未填写',
        max: '描述过长'
      },
      link: {
        label: '链接',
        placeholder: '请输入链接',
        required: '链接未填写',
        invalid: '链接应该为URL格式'
      },
      buttonText: {
        label: '按钮文字',
        placeholder: '请输入按钮文字'
      },
      newsDescription: {
        label: '描述',
        placeholder: '请输入描述',
        required: '描述未填写',
        max: '描述过长'
      },
      imageUrl: {
        label: '图片链接',
        placeholder: '请输入图片链接'
      },
      file: {
        label: '文件上传',
        button: '上传文件'
      }
    },
    templateTypes: {
      text: '纯文本',
      card: '文本卡片',
      news: '图文消息',
      file: '文件'
    },
    messages: {
      createSuccess: '企微RPA模板创建成功',
      updateSuccess: '企微RPA模板更新成功',
      saveFailed: '保存企微RPA模板失败'
    }
  },

  // 企微配置
  wechatConfig: {
    // 搜索表单
    search: {
      name: '配置名称',
      namePlaceholder: '请输入配置名称',
      corpId: '企业ID',
      corpIdPlaceholder: '请输入企业ID',
      agentId: '应用ID',
      agentIdPlaceholder: '请输入应用ID',
      searchButton: '搜索',
      resetButton: '重置',
      createButton: '新建配置'
    },

    // 表格列
    table: {
      name: '配置名称',
      corpId: '企业ID',
      agentId: '应用ID',
      status: '状态',
      testStatus: '测试状态',
      ifDefault: '默认配置',
      actions: '操作',
      view: '查看',
      edit: '编辑',
      delete: '删除',
      setDefault: '设为默认',
      testWechat: '测试企微',
      yes: '是',
      no: '否',
      statusEnabled: '启用',
      statusDisabled: '停用',
      testStatusUntested: '未测试',
      testStatusPassed: '测试通过',
      testStatusFailed: '测试失败'
    },

    // 表单
    form: {
      title: {
        create: '新建企微配置',
        edit: '编辑企微配置',
        view: '查看企微配置'
      },
      name: '配置名称',
      namePlaceholder: '请输入配置名称',
      nameRequired: '请输入配置名称',
      nameMax: '配置名称长度不能超过100',
      description: '配置描述',
      descriptionPlaceholder: '请输入配置描述',
      descriptionMax: '配置描述长度不能超过500',
      corpId: '企业ID',
      corpIdPlaceholder: '请输入企业ID',
      corpIdRequired: '请输入企业ID',
      agentId: '应用ID',
      agentIdPlaceholder: '请输入应用ID',
      agentIdRequired: '请输入应用ID',
      secret: '应用Secret',
      secretPlaceholder: '请输入应用Secret',
      secretRequired: '请输入应用Secret',
      ifDefault: '设为默认配置',
      cancelButton: '取消',
      confirmButton: '确定'
    },

    // 测试配置
    test: {
      resultTitle: '测试结果',
      successMessage: '测试成功',
      failureMessage: '测试失败',
      closeButton: '关闭'
    },

    // 删除确认
    delete: {
      title: '删除确认',
      message: '确定要删除企微配置"{name}"吗？',
      cancelButton: '取消',
      confirmButton: '确定'
    },

    // 消息提示
    messages: {
      createSuccess: '企微配置创建成功',
      createFailed: '企微配置创建失败',
      updateSuccess: '企微配置更新成功',
      updateFailed: '企微配置更新失败',
      deleteSuccess: '企微配置删除成功',
      deleteFailed: '企微配置删除失败',
      setDefaultSuccess: '已设为默认配置',
      setDefaultFailed: '设置默认配置失败'
    }
  },

  // 企微API配置页面（保留旧结构以兼容）
  wechatWorkConfig: {
    filters: {
      namePlaceholder: '配置名称',
      corpIdPlaceholder: '企业ID',
      agentIdPlaceholder: '应用ID',
      statusPlaceholder: '状态'
    },
    buttons: {
      search: '搜索',
      reset: '重置',
      create: '新建'
    },
    table: {
      name: '配置名称',
      corpId: '企业ID',
      agentId: '应用ID',
      status: '状态',
      isDefault: '是否默认',
      remark: '备注',
      actions: '操作'
    },
    actions: {
      view: '查看',
      edit: '编辑',
      setDefault: '设为默认',
      delete: '删除',
      deleteConfirm: '确定要删除这个企微API配置吗？'
    },
    detail: {
      title: '企微API配置详情',
      name: '配置名称',
      status: '状态',
      corpId: '企业ID',
      agentId: '应用ID',
      secret: '应用Secret',
      isDefault: '是否默认',
      remark: '备注',
      createdAt: '创建时间',
      updatedAt: '更新时间'
    },
    form: {
      title: {
        create: '新建企微API配置',
        edit: '编辑企微API配置'
      },
      name: {
        label: '配置名称',
        placeholder: '请输入配置名称',
        required: '请输入配置名称',
        max: '配置名称不能超过50个字符'
      },
      corpId: {
        label: '企业ID',
        placeholder: '请输入企业ID',
        required: '请输入企业ID'
      },
      agentId: {
        label: '应用ID',
        placeholder: '请输入应用ID',
        required: '请输入应用ID'
      },
      secret: {
        label: '应用Secret',
        placeholder: '请输入应用Secret',
        required: '请输入应用Secret'
      },
      status: {
        label: '状态',
        placeholder: '请选择状态',
        required: '请选择状态'
      },
      remark: {
        label: '备注',
        placeholder: '请输入备注信息（最多200字）'
      },
      test: {
        button: '测试连接',
        success: '测试成功',
        failure: '测试失败',
        fillFirst: '请先填写完整的配置信息'
      }
    },
    messages: {
      deleteSuccess: '删除成功',
      setDefaultSuccess: '设置默认成功',
      testSuccess: '测试连接成功',
      testFailure: '测试连接失败',
      notTested: '该配置尚未通过测试',
      createSuccess: '创建成功',
      updateSuccess: '更新成功'
    }
  },

  // 企微RPA配置
  wechatWorkRpaConfig: {
    // 搜索表单
    search: {
      name: '配置名称',
      namePlaceholder: '请输入配置名称',
      searchButton: '搜索',
      resetButton: '重置',
      createButton: '新建配置'
    },

    // 表格列
    table: {
      name: '配置名称',
      status: '状态',
      testStatus: '测试状态',
      ifDefault: '默认配置',
      actions: '操作',
      view: '查看',
      edit: '编辑',
      delete: '删除',
      setDefault: '设为默认',
      testRpa: '测试RPA',
      yes: '是',
      no: '否',
      statusEnabled: '启用',
      statusDisabled: '停用',
      testStatusUntested: '未测试',
      testStatusPassed: '测试通过',
      testStatusFailed: '测试失败'
    },

    // 表单
    form: {
      title: {
        create: '新建企微RPA配置',
        edit: '编辑企微RPA配置',
        view: '查看企微RPA配置'
      },
      name: '配置名称',
      namePlaceholder: '请输入配置名称',
      nameRequired: '请输入配置名称',
      nameMax: '配置名称长度不能超过100',
      description: '配置描述',
      descriptionPlaceholder: '请输入配置描述',
      descriptionMax: '配置描述长度不能超过500',
      secret: '应用Secret',
      secretPlaceholder: '请输入应用Secret',
      secretRequired: '请输入应用Secret',
      ifDefault: '设为默认配置',
      cancelButton: '取消',
      confirmButton: '确定'
    },

    // 测试配置
    test: {
      resultTitle: '测试结果',
      successMessage: '测试成功',
      failureMessage: '测试失败',
      closeButton: '关闭'
    },

    // 删除确认
    delete: {
      title: '删除确认',
      message: '确定要删除企微RPA配置"{name}"吗？',
      cancelButton: '取消',
      confirmButton: '确定'
    },

    // 消息提示
    messages: {
      createSuccess: '企微RPA配置创建成功',
      createFailed: '企微RPA配置创建失败',
      updateSuccess: '企微RPA配置更新成功',
      updateFailed: '企微RPA配置更新失败',
      deleteSuccess: '企微RPA配置删除成功',
      deleteFailed: '企微RPA配置删除失败',
      setDefaultSuccess: '已设为默认配置',
      setDefaultFailed: '设置默认配置失败'
    }
  }
}
